import { Add, Trash } from 'iconsax-react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import Text from '../../assets/styles/Text';
import { cartStore } from '../../stores/cartStore';
import ReactPortal from '../ReactPortal';
import * as styles from './styles';

export default function Cart({ show }) {
  const [select, setSelect] = useState(1);
  const [quantity, setQuantity] = useState(1);

  const { closeCart, cart, removeFromCart } = cartStore();

  const [price, setPrice] = useState('0,00');

  useEffect(() => {
    let total = 0;

    cart.forEach((item) => {
      if (item.type === 'plan') {
        if (select === 1) total += item.total1;
        if (select === 2) total += item.total2;
        if (select === 3) total += item.total3;
      }

      if (item.type === 'upgrade') {
        total += (quantity || 1) * (item.price || 0);
      }
    });

    setPrice(total.toFixed(2).replace('.', ','));
  }, [cart, select, quantity]);

  function handleIncrease() {
    setQuantity((prev) => prev + 1);
  }

  function handleDecrease() {
    setQuantity((prev) => (prev - 1 < 0 ? 0 : prev - 1));
  }


  if (!show) return null;

  return (
    <ReactPortal containerId="Cart">
      <styles.Modal onClick={closeCart}>
        <styles.Container onClick={(e) => e.stopPropagation()}>
          <styles.Title>
            <Text.H3>Carrinho de compras</Text.H3>

            <styles.ButtonClose onClick={closeCart}>
              <Add />
            </styles.ButtonClose>
          </styles.Title>

          <styles.Form>
            {cart &&
              cart
                .filter((item) => item.type === 'plan')
                .map((item) => (
                  <styles.Plans key={item.id}>
                    <styles.PlanHeader>
                      <styles.PlanTitle>
                        <Text.H4 $bold>{item.subName}</Text.H4>
                        <Text.H2 $bold>{item.name}</Text.H2>
                      </styles.PlanTitle>

                      <button
                        type="button"
                        onClick={() => removeFromCart(item.type)}
                      >
                        <Trash />
                      </button>
                    </styles.PlanHeader>

                    <styles.PlanInfo $select={select}>
                      <button type="button" onClick={() => setSelect(1)}>
                        <Text.P $bold>3 Dias</Text.P>
                      </button>
                      <button type="button" onClick={() => setSelect(2)}>
                        <Text.P $bold>7 Dias</Text.P>
                      </button>
                      <button type="button" onClick={() => setSelect(3)}>
                        <Text.P $bold>30 Dias</Text.P>
                      </button>
                    </styles.PlanInfo>

                    <Text.Span $bold>
                      R${' '}
                      {select === 1 && item.total1.toFixed(2).replace('.', ',')}
                      {select === 2 && item.total2.toFixed(2).replace('.', ',')}
                      {select === 3 && item.total3.toFixed(2).replace('.', ',')}
                    </Text.Span>
                  </styles.Plans>
                ))}

            {cart &&
              cart
                .filter((item) => item.type === 'upgrade')
                .map((item) => (
                  <styles.Plans key={item.id}>
                    <styles.PlanHeader>
                      <styles.PlanTitle>
                        <Text.H4 $bold>{item.subName}</Text.H4>
                        <Text.H2 $bold>{item.name}</Text.H2>
                      </styles.PlanTitle>

                      <button
                        type="button"
                        onClick={() => removeFromCart(item.type)}
                      >
                        <Trash size="32" />
                      </button>
                    </styles.PlanHeader>

                    <styles.PlanQuantity>
                      <button type="button" onClick={handleDecrease}>
                        <Text.P $bold>-</Text.P>
                      </button>

                      <Text.P $bold>{quantity}</Text.P>

                      <button type="button" onClick={handleIncrease}>
                        <Text.P $bold>+</Text.P>
                      </button>
                    </styles.PlanQuantity>

                    <Text.Span $bold>
                      R$ {(item.price * quantity).toFixed(2).replace('.', ',')}
                    </Text.Span>
                  </styles.Plans>
                ))}
          </styles.Form>

          <styles.Footer>
            <Text.P $bold>Valor a pagar: R${price}</Text.P>
          </styles.Footer>
        </styles.Container>
      </styles.Modal>
    </ReactPortal>
  );
}

Cart.propTypes = {
  show: PropTypes.bool.isRequired,
};
